import script from "./CanteenProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CanteenProductForm.vue?vue&type=script&setup=true&lang=js"

import "./CanteenProductForm.vue?vue&type=style&index=0&id=671ad5b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671ad5b0"]])

export default __exports__